import Cookies from 'js-cookie';

import {
  FilesUtils,
  EnvironmentUtils,
  reportAppError,
} from '@anyx/shared-utils';


import { ANYCHAT_API_HOST } from './constants';

export const exportCsv = async ({
  uri,
  params,
  method = 'GET',
  body,
}: {
  uri: string;
  params?: Record<string, unknown>;
  method?: 'GET' | 'POST';
  body?: BodyInit;
}): Promise<boolean> => {
  const host = ANYCHAT_API_HOST[EnvironmentUtils.getCurrentEnvironment()];

  if (!host) return false;

  let extendUri = `${host}/${uri}`;

  if (params) {
    const builtQueryParams = [];

    for (const [key, value] of Object.entries(params)) {
      if (typeof value === 'undefined') continue;

      if (Array.isArray(value)) {
        value.forEach((v) => builtQueryParams.push(`${key}=${v}`));
      } else {
        builtQueryParams.push(`${key}=${value}`);
      }
    }

    extendUri = `${extendUri}?${builtQueryParams.join('&')}`;
  }
  try {
    const res = await fetch(extendUri, {
      method,
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${Cookies.get('authorization')}`,
      }),
      body,
    });

    if (!res.ok) throw new Error('Failed to export CSV');

    const data = await res.text();
    const headerData = await res.headers.get('Content-Disposition');
    const backendName = headerData?.match(/filename="?([^;"]+)?/)?.[1];
    const backendNameUTF8 = headerData?.match(/filename\*=UTF-8''([^;"]+)?/)?.[1];
    const decodedBackendNameUTF8 = backendNameUTF8
      ? decodeURIComponent(backendNameUTF8)
      : backendNameUTF8;
    const fileName = backendName ?? decodedBackendNameUTF8 ?? 'export.csv';
    const csvData = new Blob([data], { type: 'text/csv;charset=UTF-8' });
    FilesUtils.download(csvData, fileName);

    return true;
  } catch (error) {
    reportAppError(error);

    return false;
  }
};
